import React, { useEffect, useState } from "react";
import Lang from "../../userPreferences/staticWords";

const HOC = (
  successDesign,
  loadingDesign,
  screenNO,
  errorDesign,
  responseOfRequest,
  errorLibrary,
  outlineDesign,
  reloading,
  ...params
) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (isLoading && (!responseOfRequest || responseOfRequest.status > 206)) {
      setTimeout(() => {
        setIsLoading(false);
      }, 5000);
    }
  }, [reloading?.tryAgain ?? null]);

  const reloadingTrigger = reloading
    ? () => {
        reloading.setTryAgain(!reloading.tryAgain);
        setIsLoading(true);
      }
    : undefined;

  const mainRender = () => {
    if (responseOfRequest?.status <= 206) {
      return successDesign(responseOfRequest, Lang, ...params);
    } else {
      if (isLoading === true) {
        //param for specific loading screen\
        return loadingDesign(screenNO);
      } else {
        // clearTimeout(loadingDuration);
        const errorComponent = errorLibrary(responseOfRequest, errorDesign);
        return errorComponent.returnedComponent(
          errorComponent.uiMessage,
          errorComponent.status,
          reloadingTrigger
        );
      }
    }
  };
  return <>{outlineDesign(mainRender, Lang, ...params)}</>;
};

export default HOC;
